import { globalGetService } from '@/utils/globalApiServices';
import {
  Reseller,
  ResellerParams,
  ResellerSuggestionParams,
  ResellerSuggestion,
} from './types';
import { Pagination } from '@/utils/types';

export const getResellerSuggestions = async (
  params: ResellerSuggestionParams = {
    companyNamePrefix: '',
  }
): Promise<ResellerSuggestion[]> => {
  const response = await globalGetService('csp/reseller/suggestions', params);
  return response?.ok ? (response.data as ResellerSuggestion[]) : [];
};

export const getResellers = async (params: ResellerParams = {}) => {
  const response = await globalGetService('csp/reseller', params);
  return response?.ok ? (response.data as Pagination<Reseller>) : undefined;
};

export const getReseller = async (resellerUid: string) => {
  const response = await globalGetService(`csp/reseller/${resellerUid}`);
  return response?.ok ? (response.data as Reseller) : undefined;
};
